module.exports = __webpack_public_path__ + "301e054b9f8d6489cdbfa02c14fdd11b.svg";